import clsx from "clsx";
import { DEFAULT_DESKTOP_PROFILE_COLOR } from "../../constants";
import { useDesktopProfiles } from "../../hooks/use-desktop-profiles";

export interface DesktopProfileBadgeProps {
	fallbackColor?: string;
	className?: string;
}

export function DesktopProfileBadge({
	fallbackColor = DEFAULT_DESKTOP_PROFILE_COLOR,
	className,
}: DesktopProfileBadgeProps) {
	const { isElectron, currentProfile } = useDesktopProfiles();
	if (!isElectron || !currentProfile) return null;

	return (
		<div
			className={clsx(
				"absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full",
				"border-2 border-surface-default shadow-xs pointer-events-none",
				className,
			)}
			style={{
				backgroundColor: currentProfile.color || fallbackColor,
			}}
		/>
	);
}
